import makeStyles from '@material-ui/core/styles/makeStyles';
import { CourseTheme } from 'assets/themes/Course';

interface IEmbedProps {
  content: string;
  type: number;
}

const useStyles = makeStyles<CourseTheme>((theme) => ({
  lessonPage: {
    color: theme.variables.courseTheme.text,
    '& > iframe,object,embed': {
      width: 'auto',
      height: '100%',
      minWidth: '100%',
      minHeight: '500px',
      display: 'block',
    },
    '@media (min-aspect-ratio: 16/9)': {
      '& > iframe,object,embed': {
        width: '100%',
      },
    },
    '@media (max-aspect-ratio: 16/9)': {
      '& > iframe,object,embed': {
        width: 'auto',
      },
    },
  },
  embedBackgroud: {
    padding: 20,
    borderRadius: 4,
    color: theme.variables.courseTheme.text,
  },
}));

const Embed = ({ content, type }: IEmbedProps) => {
  const classes = useStyles();

  const createElementsToEmbeded = () => {
    let div = document.createElement('div');
    div.innerHTML = content;
    let elements = div.getElementsByTagName('link');
    while (elements[0]) elements[0].parentNode.removeChild(elements[0]);
    return div.innerHTML;
  };

  return (
    <div
      className={classes.lessonPage}
      id='lesson-type-text'
      dangerouslySetInnerHTML={{ __html: createElementsToEmbeded() }}
    ></div>
  );
};

export default Embed;
